"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createdClaimSchema = void 0;
var constants_1 = require("../constants");
exports.createdClaimSchema = {
    type: 'object',
    required: [
        'approvedLenderFinancialInstitutionCode',
        'approvedLenderReferenceNumber',
        'approvedLenderTransitNumber',
        'cmhcLoanAccountNumber',
        'claimTypeIndicator',
    ],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'Should be a string with a maximum of 3 characters',
        },
        approvedLenderReferenceNumber: {
            type: 'string',
            isNotEmpty: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            pattern: '^[0-9]{5}',
            errorMessage: 'Should be a string with a maximum of 5 characters',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_1.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
    },
};
